import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { useUscLabel } from "../../../../../utils/labels";
import Disclosure from "../../../styles/molecules/Disclosure";
import Icon from "../../../styles/Icon";
import List from "../../../styles/atoms/List";
import Text from "../../../styles/atoms/Text";
import * as CarDetailsStyles from "../CarDetails.styles";
import { useBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { groupEquipmentIntoCategories } from "../../../../../utils/helpers";

const Equipment = (): JSX.Element | null => {
    const equipment = useUscSelector((state) => state.vehicle.result?.product.equipment || []);
    const disabledCategories = useUscSelector((state) => state.uscSettings.disabledEquipmentCategories);
    const title = useUscLabel("uscPdpEquipmentTitle");

    const categories = groupEquipmentIntoCategories(equipment);

    const isMobile = useBreakpoint("down", "md");

    if (!categories.length) return null;

    return (
        <Disclosure variant="specs" ariaLabel={title}>
            <summary>
                <div>
                    {!isMobile && <Icon variant="manual" iconSize="medium" />}
                    <Text tag="h3" variant="h6">
                        {title}
                    </Text>
                </div>
                <Icon variant="chevron-down" />
            </summary>
            <CarDetailsStyles.DisclosureBody>
                {categories
                    .filter((category) => !disabledCategories.includes(category.code))
                    .map((category) => (
                        <div key={category.code}>
                            <Text tag="h4" variant="h6">
                                {category.title}
                            </Text>
                            <List variant="bullet" columns={2}>
                                {category.equipment.map((item, index) => (
                                    // eslint-disable-next-line react/no-array-index-key
                                    <li key={`${item}-${index}`}>{item}</li>
                                ))}
                            </List>
                        </div>
                    ))}
            </CarDetailsStyles.DisclosureBody>
        </Disclosure>
    );
};

export default Equipment;
